import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useLabel } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

import { capitalize } from 'common/utils/capitalize';
import BonusStatus from 'components/ClientProfile/Bonuses/FreeBets/BonusStatus';
import FreeBetsTableItemExpanded from 'components/ClientProfile/Bonuses/FreeBets/FreeBetsTableItemExpanded';

const FreeBetsTableItem = ({ freeBet }) => {
  const { freeBet: { name, productType } = {} } = freeBet;

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleIsExpanded = useCallback(() => {
    setIsExpanded(isExpanded => !isExpanded);
  }, [setIsExpanded]);

  const bonusInfoClassName = cx('bonus-info-container', { active: isExpanded });

  const bonusTypeTranslation = {
    SPORTSBOOK: 'profile_bonuses_sportsbook',
  };

  const label = useLabel(bonusTypeTranslation[productType]);

  return (
    <div className="bonus-history-list-item sportsbook">
      <div className={bonusInfoClassName} onClick={toggleIsExpanded}>
        <div className="bonus-info">
          <span className="title-text">{capitalize(name)}</span>
          <span className="product-label">
            <span className="sub-title-text">
              <Label message="Product" />:
            </span>
            <span className="title-small-text">{capitalize(label)}</span>
          </span>
        </div>
        <div className="arrow-container">
          <Icon className="icon-arrow-down" name="arrow-down" />
        </div>
      </div>
      <div className="bonus-status-container">
        <BonusStatus bonus={freeBet} />
      </div>
      {isExpanded && <FreeBetsTableItemExpanded freeBet={freeBet} />}
    </div>
  );
};

FreeBetsTableItem.propTypes = { freeBet: PropTypes.object.isRequired };

export default FreeBetsTableItem;
